// src/pages/LoyaltyProgramsPage.js
import React, { useState } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import DashboardLayout from "../../components/test/DashboardLayout";
import ProgramCard from "../../components/dashboard/ProgramCard";
import CreateProgramModal from "../../components/modals/CreateProgramModal";
import {useParams} from "react-router-dom";

const LoyaltyProgramsPage = () => {
    const {userId, businessId} = useParams();

    const [isModalOpen, setIsModalOpen] = useState(false);

    // Mock Data for existing loyalty programs
    const [loyaltyPrograms, setLoyaltyPrograms] = useState([
        {
            id: 'prog-001',
            name: 'Standard Points Program',
            type: 'Point-based',
            description: 'Earn 1 point for every R1 spent. Redeem 100 points for R5 off.',
            status: 'Active',
            members: 1025,
            pointsIssued: 150000,
            rewardsRedeemed: 750,
        },
        {
            id: 'prog-002',
            name: 'VIP Tier Rewards',
            type: 'Tiered',
            description: 'Bronze, Silver, Gold tiers with increasing benefits.',
            status: 'Active',
            members: 350,
            tiers: ['Bronze', 'Silver', 'Gold'],
        },
        {
            id: 'prog-003',
            name: 'Seasonal Spend & Save',
            type: 'Spend-based',
            description: 'Spend R100 get 10% off. Spend R250 get 20% off.',
            status: 'Inactive',
            members: 0,
            thresholds: ['R100', 'R250'],
        },
    ]);

    const handleCreateProgram = (newProgram) => {
        setLoyaltyPrograms([...loyaltyPrograms, { ...newProgram, id: `prog-${Date.now()}`, members: 0, status: 'Active' }]);
        setIsModalOpen(false);
    };

    const handleEditProgram = (updatedProgram) => {
        setLoyaltyPrograms(
            loyaltyPrograms.map((program) =>
                program.id === updatedProgram.id ? updatedProgram : program
            )
        );
        setIsModalOpen(false); // Close modal after edit
    };

    const handleDeactivateProgram = (id) => {
        setLoyaltyPrograms(
            loyaltyPrograms.map((program) =>
                program.id === id ? { ...program, status: 'Inactive' } : program
            )
        );
    };

    const handleActivateProgram = (id) => {
        setLoyaltyPrograms(
            loyaltyPrograms.map((program) =>
                program.id === id ? { ...program, status: 'Active' } : program
            )
        );
    };


    return (
        <DashboardLayout userId={userId} businessId={businessId}>
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold text-gray-800">Loyalty Programs</h1>
                <button
                    onClick={() => setIsModalOpen(true)}
                    className="bg-indigo-600 text-white px-5 py-2 rounded-lg flex items-center space-x-2 hover:bg-indigo-700 transition duration-200 shadow-md"
                >
                    <PlusIcon className="h-5 w-5" />
                    <span>Create New Program</span>
                </button>
            </div>

            {loyaltyPrograms.length === 0 ? (
                <div className="bg-white rounded-lg shadow-md p-8 text-center border-dashed border-2 border-gray-300">
                    <p className="text-xl font-semibold text-gray-700 mb-4">No loyalty programs set up yet!</p>
                    <p className="text-gray-500 mb-6">Start building stronger customer relationships by creating your first program.</p>
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="bg-indigo-600 text-white px-6 py-3 rounded-lg flex items-center space-x-2 mx-auto hover:bg-indigo-700 transition duration-200 shadow-lg"
                    >
                        <PlusIcon className="h-6 w-6" />
                        <span>Create Your First Program</span>
                    </button>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {loyaltyPrograms.map((program) => (
                        <ProgramCard
                            key={program.id}
                            program={program}
                            onEdit={() => setIsModalOpen(true)} // In a real app, pass the program to edit
                            onDeactivate={handleDeactivateProgram}
                            onActivate={handleActivateProgram}
                        />
                    ))}
                </div>
            )}

            {/* Modal for creating/editing programs */}
            <CreateProgramModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onCreate={handleCreateProgram}
                onEdit={handleEditProgram} // Pass edit handler
                // Optional: If editing, pass current program data here
                // programToEdit={selectedProgramForEdit}
            />
        </DashboardLayout>
    );
};

export default LoyaltyProgramsPage;